import type { SubmissionStatus } from '@/api/types';

const MAP: Record<SubmissionStatus, { cls: string; label: string }> = {
  PENDING:        { cls: 'neutral', label: 'Ожидает' },
  PROCESSING:     { cls: 'neutral', label: 'Обработка' },
  APPROVED:       { cls: 'success', label: 'Одобрено' },
  REJECTED:       { cls: 'error',   label: 'Отклонено' },
  MANUAL_REVIEW:  { cls: 'warn',    label: 'На проверке' },
  SHADOWBANNED:   { cls: 'error',   label: 'Заморожено' },
};

export function StatusChip({ status }: { status: SubmissionStatus }) {
  const m = MAP[status];
  return <span className={`chip ${m.cls}`}>{m.label}</span>;
}
